import { mod11Verifier } from './mod11Verifier';

interface IsNationalIdOptions {
  min: number;
  max: number;
}
const splitNationalId = (id: string): string[] => id.split('-');
const isInRange = (x: number, min: number, max: number) => x >= min && x <= max;

const isNationalId = (id: unknown, { min, max }: IsNationalIdOptions) => {
  if (typeof id !== 'string') {
    return false;
  }
  const [digits, verifier] = splitNationalId(id);
  return (
    isInRange(Number(digits.replace(/\W+/g, '')), min, max) &&
    mod11Verifier(digits, verifier)
  );
};

export { isNationalId };
